// main.js
import { createApp, watch } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';

import { createI18n } from 'vue-i18n';
import { createHead } from '@vueuse/head'; //  Add this line

import '@/assets/tailwind.css';


import router from './router';

// Import translation files
import fr from './i18n/fr.json';
import es from './i18n/es.json';
import en from './i18n/en.json';
import de from './i18n/de.json';
import ar from './i18n/ar.json';

// Retrieve saved language or set default to French
const storedLang = localStorage.getItem('lang') || 'fr';

const i18n = createI18n({
  legacy: false,
  locale: storedLang,
  fallbackLocale: 'fr',
  messages: { fr, es, en, de, ar }
});

const app = createApp(App);
const pinia = createPinia(); // Add this line
const head = createHead()

app.use(router).use(i18n).use(pinia).use(head).mount('#app');

// Adjust page direction based on language
const setDirection = (lang) => {
  document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
};
setDirection(storedLang);

watch(() => i18n.global.locale.value, (newLang) => {
  localStorage.setItem('lang', newLang);
  setDirection(newLang);
});
